import React from 'react';
import PropTypes from 'prop-types';
import { getPhoneNumber } from '../../utils/index';
import ThdLogo from '../../themes/svg/thdLogo';
import PhoneIcon from '../../themes/svg/icon_phone.svg';

const EstimateModeHeader = ({ originMODE }) => {
  let { mandiBaseUrl } = window.globalConfig.globalPaths;
  const len = mandiBaseUrl.length;
  if (mandiBaseUrl[len - 1] === '/') {
    mandiBaseUrl = mandiBaseUrl.substring(0, len - 1);
  }

  const phoneNumber = getPhoneNumber(originMODE);

  return (
    <div className="captive-header-container">
      <div className="grid center">
        <div className="row">
          <div className="column col-one">
            <div className="thd-logo-img">
              <a href="http://homedepot.com">
                <ThdLogo />
              </a>
            </div>
            <div className="header-message">
              <span>You&rsquo;re shopping</span>
              <br />
              <span><b>Custom Blinds</b></span>
            </div>
          </div>
          <div className="column col-two">
            <div className="header-phone-num">
              <p>Questions? <span className="phone-num-color">{phoneNumber}</span></p>
            </div>
            <div className="header-user-details">
              <span className="phone-icon">
                <a href={`tel:${phoneNumber}`}><PhoneIcon /></a>
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col my-window-treatments-link">
            <a id="gccir_MyWindowTreatmentLink" href={`${mandiBaseUrl}/MyWindowTreatments`} target="_self">
              My Window Treatments
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

EstimateModeHeader.propTypes = {
  originMODE: PropTypes.string.isRequired,
};


export default EstimateModeHeader;

